import { render } from "./StairwellFlyer.vue?vue&type=template&id=5d0b6070&scoped=true"
import script from "./StairwellFlyer.vue?vue&type=script&lang=js"
export * from "./StairwellFlyer.vue?vue&type=script&lang=js"

import "./StairwellFlyer.vue?vue&type=style&index=0&id=5d0b6070&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0b6070"]])

export default __exports__